import React from 'react'
import { ACTIVITY_IMPORTS_TABLE_SCOPE, DEFAULT_ACTIVITY_IMPORT_COLUMN_IDS } from '../ActivityTable.constants'
import ActivityTabTable, { ActivityTabTableProps } from '../components/ActivityTabTable'

type ActivityImportsTableProps = Pick<ActivityTabTableProps, 'rows' | 'onOpenPanel'>

export const ActivityImportsTable = (props: ActivityImportsTableProps) => (
    <ActivityTabTable
        {...props}
        scope={ACTIVITY_IMPORTS_TABLE_SCOPE}
        defaultColumnIds={DEFAULT_ACTIVITY_IMPORT_COLUMN_IDS}
        searchPlaceholder="Import Search"
        noMatchesLabel="imports"
        emptyTitle="No imports to display"
        emptySubtitle="External activities with 'Processing' status will appear here"
    />
)

export default ActivityImportsTable
